// extracted by mini-css-extract-plugin
export default {"grid-box":"Grid_grid-box__mjwr+"};